import React, { useEffect, useState } from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTheme } from './hooks/useTheme';

type PageModelType = { page: number, size: number };

type PaginationProps = {
    pageOption?: number[];
    showEntries: number;
    setShowEntries: (value: number) => void;
    totalLength: number;
    paginationModel: PageModelType;
    setPaginationModel: (value: PageModelType) => void;
    setIsRefresh?: (value: boolean) => void;
}

const Pagination = ({ pageOption = [5, 10, 20, 50, 100], showEntries, setShowEntries, totalLength, paginationModel, setPaginationModel, setIsRefresh }: PaginationProps) => {
    const { themeStyles, theme } = useTheme();

    const textColor =
        theme === "dark"
            ? `${themeStyles.main.textSubHeadingColor}`
            : `${themeStyles.main.textHeadingColor}`;

    const [paginationOption, setPaginationOption] = useState<number[]>([1]);

    useEffect(() => {
        if (totalLength > 0) {
            const array: number[] = [];

            for (
                let i = 1;
                i <= Math.ceil(totalLength / paginationModel?.size);
                i++
            ) {
                array.push(i);
            }

            setPaginationOption(array);
        }
    }, [totalLength, paginationModel]);

    const handleShowEntriesChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setPaginationModel({
            page: 0,
            size: parseInt(e.target.value),
        });
        setShowEntries(parseInt(e.target.value));
        setIsRefresh && setIsRefresh(true);
    };

    const previousPagnation = () => {
        if (paginationModel.page > 0) {
            setPaginationModel({
                ...paginationModel,
                page: paginationModel.page - 1,
            });

            setIsRefresh && setIsRefresh(true);
        }
    };

    const nextPagination = () => {
        if (paginationModel.page < paginationOption[paginationOption.length - 2]) {
            setPaginationModel({
                ...paginationModel,
                page: paginationModel.page + 1,
            });

            setIsRefresh && setIsRefresh(true);
        }
    };

    return (
        <div className="w-full text-right flex items-center pt-3 gap-4 justify-between px-4">
            <p className={`text-sm flex-1 ${textColor}`}>
                {` ${(paginationModel.page * showEntries) + 1} to ${(showEntries * (paginationModel.page + 1)) >= totalLength ? totalLength : showEntries * (paginationModel.page + 1)} of ${totalLength} entries`}
            </p>
            <div className="flex items-center">
                <select
                    className="text-sm text-[#4A4A4A] border border-[#D1D5DB] rounded-md h-7 mx-4 outline-none"
                    value={showEntries}
                    onChange={handleShowEntriesChange}
                >
                    {pageOption?.map((item: number) => (
                        <option key={item} value={item}>
                            {item}
                        </option>
                    ))}
                </select>
                <ul className="flex items-center">
                    <li
                        style={{
                            backgroundColor:
                                paginationModel.page <= 0 ? "rgba(169, 169, 169, 0.3)" : "#A9A9A9",
                            cursor: paginationModel.page <= 0 ? "default" : "pointer",
                        }}
                        className="flex items-center justify-center w-7 h-7 rounded-[20%] p-1"
                        onClick={previousPagnation}
                    >
                        <ArrowBackIosIcon style={{ fill: "#fff" }} />
                    </li>

                    <li className={`flex items-center justify-center text-sm w-fit h-7 rounded-md p-1 px-2 ${textColor}`}>
                        {`${paginationModel.page + 1} - ${paginationOption[paginationOption.length - 1]} of ${paginationOption[paginationOption.length - 1]} page`}
                    </li>

                    <li
                        style={{
                            backgroundColor:
                                totalLength <= paginationModel.size || paginationModel.page >= paginationOption[paginationOption.length - 2]
                                    ? "rgba(169, 169, 169, 0.3)"
                                    : "#A9A9A9",
                            cursor: totalLength <= paginationModel.size || paginationModel.page >= paginationOption[paginationOption.length - 2]
                                ? "default"
                                : "pointer",
                        }}

                        className="flex items-center justify-center w-7 h-7 rounded-[20%] p-1"
                        onClick={nextPagination}
                    >
                        <ArrowForwardIosIcon style={{ fill: "#fff" }} />
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Pagination;